import clsx from 'clsx'
import { useMemo } from 'preact/hooks'
import { useSwatches } from '@/components/hooks/useSwatches'

export function ResultsSwatches({ result, swatches, onSelectSwatch }) {
  if (!swatches || swatches.length === 0) return null

  return (
    <>
      <div className="flex flex-row flex-wrap gap-x-0.375 gap-y-0.25 items-center justify-start">
        {swatches.slice(0, 3).map((swatch) => {
          return (
            <Swatch
              key={swatch.handle}
              swatch={swatch}
              onSelectSwatch={onSelectSwatch}
              isCurrentSwatch={swatch.handle === result.handle}
            />
          )
        })}
        {swatches.length > 3 && (
          <span className="paragraph-xs text-type-black-tertiary">+{swatches.length - 3}</span>
        )}
      </div>
    </>
  )
}

function Swatch({ swatch, onSelectSwatch, isCurrentSwatch }) {
  function handleClick() {
    onSelectSwatch(swatch.handle)
  }

  const colour = useMemo(() => {
    const tag = swatch?.tags?.find((tag) => tag.includes('Hex'))
    if (!tag) return 'var(--colour-accent)'

    return tag.split('-').pop()
  }, [swatch])

  const isLightColour = useMemo(() => {
    const hexColour = colour.toLowerCase()
    return !hexColour || hexColour === '#ffffff' || hexColour === '#fff' || hexColour === 'white'
  }, [colour])

  const criteria = useMemo(() => ({
    tags: swatch?.tags ?? []
  }), [swatch?.tags])

  const altSwatch = useSwatches(criteria)

  return (
    <button
      className={clsx('shrink-0 flex size-0.875 bg-[--bg-colour] rounded-full border border-[--border-colour] outline outline-1 outline-transparent outline-offset-0 overflow-hidden transition-all', isCurrentSwatch ? '!outline-[--bg-colour]' : 'outline-borders-default')}
      style={{
        '--bg-colour': altSwatch.length > 0 && altSwatch[0].background_colour ? altSwatch[0].background_colour : colour,
        '--border-colour': altSwatch.length > 0 && altSwatch[0].background_colour ? altSwatch[0].background_colour : 'var(--colour-secondary)',
        ...(isLightColour && { boxShadow: 'inset 0px 0px 0px 1px var(--tertiary)' })
      }}
      onClick={handleClick}
      aria-label="View product"
      data-dl-track="toggle_variant"
      data-dl-product-id={swatch.productLegacyResourceId}
      data-dl-attribute="item_colour"
      data-dl-value={swatch.colourName}
    >
      {altSwatch.length > 0 && altSwatch[0].image && (
        <img
          src={altSwatch[0].image}
          alt="Product swatch"
          className="size-full object-cover"
        />
      )}
    </button>
  )
}
